import React from "react";
import Register from "../components/Auth/Register";

export default function RegisterPage() {
  return <Register />;
}
